import {
    Box, Button, CardContent,
    Container,
    Drawer,
    Grid,
    Paper,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Typography
} from '@mui/material';
import 'dayjs/locale/ko';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { apiService } from '../../api/axiosClient';

const DialogCommunity = (props) => {
    const { postId, show, setShow } = props;
    const [list, setList] = useState([]);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await apiService.get(`/comment/${postId}`)
          setList(response.data.list);
        } catch (e) {
          console.error(e)
        }
      }
  
      fetchData();
    }, [postId]);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setShow(open);
    };

    const handleDelete = async (id) => {
        if (!window.confirm("정말로 삭제하시겠습니까?")) {
            return;
        }

        try {
            await apiService.delete(`/comment/${id}`);
            setList(prevList => prevList.filter(item => item.id !== id));
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Drawer anchor='right' open={show} onClose={toggleDrawer(false)}>
            <Container sx={{width: '800px', pt: 8, px: '2rem !important'}}>              
              <CardContent sx={{ pt: 8 }}>
                  <Box sx={{ mb: 9, textAlign: 'center' }}>
                      <Typography variant='h5' sx={{ mb: 3, lineHeight: '2rem' }}>
                        댓글
                      </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <TableContainer component={Paper} sx={{ marginTop: 4 }}>
                      {
                          list?.length > 0 ?
                              <Table>
                                  <TableHead>
                                      <TableRow>
                                          <TableCell>ID</TableCell>
                                          <TableCell>사용자 ID</TableCell>
                                          <TableCell>답변</TableCell>
                                          <TableCell>답변날자</TableCell>
                                          <TableCell></TableCell>
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                  {
                                      list.map((item, index) => (
                                          <TableRow key={index}>
                                              <TableCell>{item.id}</TableCell>
                                              <TableCell>{item.author}</TableCell>
                                              <TableCell>{item.content}</TableCell>
                                              <TableCell>
                                                {moment(item.uptime).format("YYYY-MM-DD")}
                                              </TableCell>
                                              <TableCell align="center">
                                                  <Button variant="contained" color="error" sx={{ color: '#fff !important'}} onClick={() => {handleDelete(item.id)}} >삭제</Button>
                                              </TableCell>
                                          </TableRow>
                                      ))
                                  }
                                  </TableBody>
                              </Table>
                              :
                              <Box sx={{ p: 2, textAlign: 'center' }}>
                                  <Typography variant='body2'>등록된 댓글이 없습니다.</Typography>
                              </Box>
                      }
                      </TableContainer>
                  </Grid>
              </CardContent>
            </Container>
        </Drawer>        
    )
}

export default DialogCommunity